module.exports = __webpack_public_path__ + "img/schema_verticalisateur_4a.48fbf608.svg";